import { HeadCell } from '../../models/TableProps';
import { AdminUsersHeadCellContent } from '../../models/Admin/AdminUsers';

export const ADMIN_USERS_HEAD_CELLS: HeadCell<AdminUsersHeadCellContent>[] = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: 'ID',
        sortable: false,
    },
    {
        id: 'bc_customer_no',
        numeric: false,
        disablePadding: false,
        label: 'BC_CUSTOMER_NO',
        sortable: false,
    },
    {
        id: 'company',
        numeric: false,
        disablePadding: false,
        label: 'COMPANY',
        sortable: false,
    },
    {
        id: 'email',
        numeric: false,
        disablePadding: false,
        label: 'EMAIL',
        sortable: false,
    },
    {
        id: 'first_name',
        numeric: false,
        disablePadding: false,
        label: 'NAME',
        sortable: false,
    },
    {
        id: 'tax_number',
        numeric: false,
        disablePadding: false,
        label: 'TAX_NUMBER',
        sortable: false,
    },
    {
        id: 'active',
        numeric: false,
        disablePadding: false,
        label: 'ACTIVE',
        sortable: false,
    },
    {
        id: 'more',
        numeric: true,
        disablePadding: false,
        label: 'MORE',
        sortable: false,
    },
];
